const Directives = {
	install(Vue, options) {
		/**
		 * Focus an element by default
		 * Uses nextTick to ensure that the DOM has been updated before attempting to focus the element
		 * e.g. `<input type="text" v-focus ... />`
		 * @param  {HTMLElement} el The element to focus
		 */
		Vue.directive('focus', function(el, {value}) {
			value !== false && Vue.nextTick(() => el.focus())
		})
	}
};

export default Directives;
